import type { ColumnDef } from "@tanstack/react-table";
import { isNonNull } from "~/common/utils/reducers";

export const ACTIONS_COL_WIDTH = 38 * 4;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const calculateTotalTableWidth = (columnConfig: ColumnDef<any>[]) => {
  const sizes = columnConfig.map((column) => column.size).filter(isNonNull);
  if (sizes.length > 0 && sizes.some((size) => size < 1)) {
    throw new Error("Not implemented");
  }
  return sizes.reduce((total, size) => total + size, 0);
};
